export default "__VITE_ASSET__B3CK$PAJ__"